export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

// Fallback values, shown only for the split second before the page reads the LIVE
// token values from the stylesheet (see useLiveTokens in ColorSwatch). The live read
// is the source of truth, so these can't make the page go stale — they just mirror
// app/frontend/styles/design-system.css to avoid a flash of empty swatches.
export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    hexLight: "#faf9f7",
    hexDark: "#1c1917",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "#ffffff",
    hexDark: "#45403a",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "#e6e2da",
    hexDark: "#534d44",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "#534d44",
    hexDark: "#e6e2da",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "#45403a",
    hexDark: "#faf9f7",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "#968c79",
    hexDark: "#b3aa99",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    hexLight: "#d4a843",
    hexDark: "#e0bd63",
  },
  {
    name: "accent-faded",
    utility: "bg-accent-faded",
    hexLight: "#faf4e1",
    hexDark: "#3a3220",
  },
  {
    name: "accent-display",
    utility: "bg-accent-display / text-accent-display",
    hexLight: "#976e2a",
    hexDark: "#ebd492",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    hexLight: "#fcd34d",
    hexDark: "#fcd34d",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    hexLight: "#fffaea",
    hexDark: "#2f2b21",
  },
  {
    name: "signal-display",
    utility: "bg-signal-display / text-signal-display",
    hexLight: "oklch(76% 0.165 82)",
    hexDark: "oklch(93% 0.13 95)",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    hexLight: "oklch(64% 0.22 25)",
    hexDark: "oklch(72% 0.20 22)",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    hexLight: "oklch(96% 0.025 25)",
    hexDark: "oklch(22% 0.05 22)",
  },
  {
    name: "danger-display",
    utility: "bg-danger-display / text-danger-display",
    hexLight: "oklch(55% 0.20 25)",
    hexDark: "oklch(82% 0.18 22)",
  },
];

export const FONTS = {
  display: "Inter",
  body: "Inter",
};
